import { render, staticRenderFns } from "./OfferMeal.vue?vue&type=template&id=98e72e50&"
import script from "./OfferMeal.vue?vue&type=script&lang=js&"
export * from "./OfferMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports